import { NOTIFICATION_REGISTRY } from "../constants";
import { TNotificationConfig } from "../types";

export const getNotificationConfig = (
  actionType: string
): TNotificationConfig | undefined => {
  return NOTIFICATION_REGISTRY[actionType];
};
